import metadata from './AddExcludedDriverPopup.metadata.json5';
import styles from './AddExcludedDriverPopup.module.scss';
import excludedDriversMessages from './ExcludedDrivers.messages';

export default {
    metadata,
    styles,
    excludedDriversMessages
};
